import React from 'react'
import Helmet from 'react-helmet'
import get from 'lodash/get'
import kebabCase from 'lodash/kebabCase'

export default function PageHead({
  title,
  title_serp,
  subtitle,
  keywords,
  description,
  siteRoot,
  canonical_link,
  shareUrl,
  image,
  hero,
  orig_path,
  path,
  cardType,
  hidden = false
}) {
  const prependSiteUrl = path => (/http/.test(path) ? path : siteRoot + path)

  return (
    <Helmet
      htmlAttributes={{ lang: 'en' }}
      bodyAttributes={{
        class: `page-${kebabCase(path)}`
      }}
    >
      <title>
        {title_serp || title}
        {subtitle ? ` - ${subtitle}` : ''}
      </title>
      {keywords && <meta name="keywords" content={keywords} />}

      <meta name="description" content={description} />

      {hidden && <meta name="robots" content="noindex, nofollow" />}

      <script type="application/ld+json">{`
        {
          "@context": "http://schema.org",
          "@type": "WebSite",
          "url": "https://www.softkraft.co"
        }
      `}</script>

      <meta name="twitter:card" content={cardType} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={shareUrl || prependSiteUrl(orig_path || path)} />
      <meta name="twitter:site" content="soft_kraft" />
      {hero ? (
        <meta property="og:image" content={prependSiteUrl(get(hero, 'image') || get(hero, 'background'))} />
      ) : (
        <meta property="og:image" content={prependSiteUrl(image)} />
      )}

      {canonical_link ? (
        <link rel="canonical" href={canonical_link} />
      ) : (
        path && (shareUrl ? <link rel="canonical" href={`${shareUrl}`} /> : <link rel="canonical" href={prependSiteUrl(orig_path || path)} />)
      )}
    </Helmet>
  )
}

PageHead.defaultProps = {
  siteRoot: 'https://www.softkraft.co',
  cardType: 'summary_large_image'
}
